import { g as getUserByName } from "../../../../../chunks/db.js";
import { s as sessionsStore } from "../../../../../chunks/session.js";
import { json } from "@sveltejs/kit";
import bcrypt from "bcrypt";
const POST = async ({ request, cookies }) => {
  const data = await request.json();
  const user = await getUserByName(data.username);
  if (!user) {
    return json({ error: "Invalid credentials" }, { status: 401 });
  }
  if (!bcrypt.compareSync(data.password, user.password)) {
    return json({ error: "Invalid credentials" }, { status: 401 });
  }
  const sessionId = crypto.randomUUID();
  sessionsStore.set(sessionId, { userId: user.id, username: user.username });
  cookies.set("session", sessionId, {
    path: "/",
    httpOnly: true,
    sameSite: "strict",
    secure: true,
    maxAge: 60 * 60 * 24
  });
  return json({ success: true });
};
const DELETE = async ({ cookies }) => {
  const sessionId = cookies.get("session");
  if (sessionId) {
    sessionsStore.delete(sessionId);
    cookies.delete("session", {
      path: "/",
      httpOnly: true,
      sameSite: "strict",
      secure: true
    });
  }
  return json({ success: true });
};
export {
  DELETE,
  POST
};
